/* empty css                              */
/* empty css                             */
//#region src/components/text/text.css.ts
var e = "_8zp7se0", t = "_8zp7se1", n = "_8zp7se2", r = "_8zp7se3 _8zp7se2";
//#endregion
export { e as i, t as n, r, n as t };

//# sourceMappingURL=text.css-DDuHJ-lZ.js.map